import React, {Component} from 'react';
import {InputItem, Modal, NavBar,Toast} from 'antd-mobile';
import "./style.less";
import {connect} from "react-redux";
import TestCode from "../../../../components/TestCode";
import {walletBindin,walletScodeVerify} from "../../../../service/homeService"
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class AddBankCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            bank:"",
            codeModal:false,
            bankData:"",
            getCodeDisabled: false,
            getCodeText: '重新获取',
        };
    }
    inputChange = key =>(e) =>{
        this.setState({ [key]: e })
    };
    addBank(){
        if(this.state.bank == ""){
            Toast.info("请输入卡号");
            return
        }
        if(this.state.getCodeText !== "重新获取"){
            Toast.info(this.state.getCodeText,3);
            return
        }
        this.getCode();
    }
    // 倒数计时
    setDownTime = (time) => {
        let timer = setInterval(() => {
            time--;
            if (time > 0) {
                this.setState({getCodeDisabled: true,getCodeText: time + 's后获取'});
            } else {
                this.setState({getCodeText: '重新获取'});
                this.setState({getCodeDisabled: false});
                clearInterval(timer);
            }
        }, 1000);
    };
    getCode(){
        let params={
            token:this.props.userInfo.token,
            source:1,
            data:{
                bankNumber:this.state.bank,
            }
        };
        walletBindin(params).then((res)=>{
            if(res.data.code === '0000'){
                this.setDownTime(60);
                this.setState({bankData:res.data.data,codeModal:true});
            }else{
                Toast.info(res.data.msg,3);
            }
        });
    }
    onClose = () => {
        this.setState({codeModal:false});
    };
    codeSubmit(v){
        if(v == ""){
            Toast.info("请输入验证码");
            return
        }
        this.setState({codeModal:false,});
        let params ={
            token:this.props.userInfo.token,
            source:1,
            data:{
                corpSerno:this.state.bankData.corpSerno,
                id:this.state.bankData.id,
                smsSendNo:this.state.bankData.smsSendNo,
                eventNo:this.state.bankData.eventNo,
                smsCode:v,
            },
        };
        walletScodeVerify(params).then((res)=>{
            if(res.data.code === '0000'){
                this.setState({bankData:this.state.bankData,bank:"",getCodeText: '重新获取'});
                if(res.data.data.status == 1){
                    Toast.info("开户中",3);
                }
               if(res.data.data.status == 2){
                   Toast.info("开户失败",3);
               }
                if(res.data.data.status == 3){
                    return Modal.alert('绑定成功！', '银行卡已绑定成功，可进行充值、提现操作', [
                        { text: '知道了',onPress: () => this.props.history.goBack()},
                    ]);
                }
            }else{
                Toast.info(res.data.msg,3);
            }
        });

    }
    render(){
        return(
            <div className="addBankCard">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}/>}
                >添加新的银行卡</NavBar>
                <div className="content">
                    <div className="list">
                        <InputItem
                            type="number"
                            maxLength={20}
                            className="inp"
                            placeholder="请输入银行卡号"
                            value={this.state.bank}
                            onChange={this.inputChange("bank")}
                            onBlur={v => window.scroll(0,0)}
                        >银行卡号</InputItem>
                    </div>
                    <div className="tishi">
                        <p>只能绑定持卡人为本人的银行卡。</p>
                    </div>
                    <div className="btn" onClick={()=>this.addBank()}>添加</div>
                </div>

                <TestCode
                    modal={this.state.codeModal}
                    onClose={this.onClose.bind(this)}
                    againEvent={this.getCode.bind(this)}
                    getCodeDisabled={this.state.getCodeDisabled}
                    getCodeText={this.state.getCodeText}
                    codeSubmit={this.codeSubmit.bind(this)}
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/member/Wallet/AddBankCard/index.js